import PropTypes from 'prop-types';
import React, { useState, useEffect, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";

// import images
import servicesIcon1 from "../../assets/images/services-icon/01.png";
import servicesIcon2 from "../../assets/images/services-icon/02.png";
import servicesIcon3 from "../../assets/images/services-icon/03.png";
import servicesIcon4 from "../../assets/images/services-icon/04.png";
import cash from "../../assets/images/cash.png";
import bank from "../../assets/images/bank.png";

// Charts
import BarChart from "../AllCharts/chartjs/barchart";
import Salesdonut from "../AllCharts/apex/salesdonut";
import Salesdonut1 from "../AllCharts/apex/salesdonut1";

import EnableNotificationsButton from "../../components/EnableNotificationsButton";
import InfiniteText from "../../components/InfiniteText";

const Dashboard = props => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [user, setUser] = useState(null);
  const [singlebtn, setSinglebtn] = useState(false);
  const [page, setPage] = useState(1);
  const [countPerPage, setCountPerPage] = useState(7);
  const [sortingBy, setSortingBy] = useState("Id");
  const [direction, setDirection] = useState("Asc");
  const [allUsers, setAllUsers] = useState([]);
  const [table1Data, setTable1Data] = useState([]);
  const [table2Data, setTable2Data] = useState([]);
  const [currentMonthRequest, setCurrentMonthRequest] = useState(false);
  const [previousMonthRequest, setPreviousMonthRequest] = useState(false);
  const [requestPercentage, setRequestPercentage] = useState(0);
  const [requestPercentageType, setRequestPercentageType] = useState(null);
  const [currentMonthStudent, setCurrentMonthStudent] = useState(false);
  const [previousMonthStudent, setPreviousMonthStudent] = useState(false);
  const [studentPercentage, setStudentPercentage] = useState(0);
  const [studentPercentageType, setStudentPercentageType] = useState(null);
  const [currentMonthPayment, setCurrentMonthPayment] = useState(false);
  const [previousMonthPayment, setPreviousMonthPayment] = useState(false);
  const [paymentPercentage, setPaymentPercentage] = useState(0);
  const [paymentPercentageType, setPaymentPercentageType] = useState(null);
  const [currentMonthPause, setCurrentMonthPause] = useState(false);
  const [previousMonthPause, setPreviousMonthPause] = useState(false);
  const [pausePercentage, setPausePercentage] = useState(0);
  const [pausePercentageType, setPausePercentageType] = useState(null);
  const [isAttendanceCancelled, setIsAttendanceCancelled] = useState(false);
  const [isFinalListCancelled, setIsFinalListCancelled] = useState(false);
  const activeUser = JSON.parse(localStorage.getItem("authUser"));
  const token = localStorage.getItem('authToken');
  const email = activeUser?.Email_Address;
  const role = activeUser?.Role;
  const todays = new Date();
  const formattedToday = todays.toISOString().split('T')[0];
  const [classDate, setClassDate] = useState(formattedToday);
  const [timeSlots, setTimeSlots] = useState([]);
  const [timeSlot1, setTimeSlot1] = useState("");
  const [timeSlot2, setTimeSlot2] = useState("");

  const fetchStudentDashboard = useCallback(async () => {
    try {
      const res = await fetch("https://api.kunalsdrumclass.com/api/GetDashboardCountByStudentId?id=" + user?.Id, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await res.json();
      setData(result?.recordsets?.[0][0] || []);
    } catch (error) {
      console.error("Error loading data:", error);
    }
  }, [user]);

  const fetchDashboardData = useCallback(async () => {
    try {
      const res = await fetch("https://api.kunalsdrumclass.com/api/GetDashboardCount", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await res.json();
      setData(result?.recordsets?.[0][0] || []);
    } catch (error) {
      console.error("Error loading data:", error);
    }
  }, []);

  const fetchFinalListData = useCallback(async () => {
    if (!classDate || !timeSlot1) return;

    try {
      const query = new URLSearchParams({
        classDate,
        timeSlot: timeSlot1,
        page,
        countPerPage,
        sortingBy,
        direction
      }).toString();

      const res = await fetch(`https://api.kunalsdrumclass.com/api/GetStudentsFinalListByDate?${query}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await res.json();
      const list = result?.recordsets?.[0] || [];
      const isClassCancelled = result?.recordsets?.[2]?.[0]?.IsClassCancelled === 1;

      setIsFinalListCancelled(isClassCancelled);
      setTable1Data(
        list.map((item, index) => ({
          ...item,
          index: (page - 1) * countPerPage + index + 1,
        }))
      );
    } catch (error) {
      console.error("Error loading final list:", error);
    }
  }, [page, timeSlot1, countPerPage, sortingBy, direction]);

  const fetchBatchSlots = useCallback(async (selectedDate) => {
    try {
      const dayName = moment(selectedDate).format("dddd");

      const res = await fetch(
        `https://api.kunalsdrumclass.com/api/GetBatchSlotsByDay?day=${dayName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const json = await res.json();

      const slots = json?.recordsets?.[0] || [];

      setTimeSlots(slots);

      // auto select first slot
      if (slots.length > 0) {
        const firstSlot = slots[0].Batch_Time;
        setTimeSlot1(firstSlot);
        setTimeSlot2(firstSlot);
      }

    } catch (error) {
      console.error("API error:", error);
    }
  }, [token]);

  const fetchAttendanceListData = useCallback(async () => {
    if (!classDate || !timeSlot2) return;

    try {
      const query = new URLSearchParams({
        classDate,
        timeSlot: timeSlot2,
        page,
        countPerPage,
        sortingBy,
        direction
      }).toString();

      const res = await fetch(`https://api.kunalsdrumclass.com/api/GetStudentsAttendanceList?${query}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await res.json();
      const list = result?.recordsets?.[0] || [];
      const isClassCancelled = result?.recordsets?.[2]?.[0]?.IsClassCancelled === 1;

      setIsAttendanceCancelled(isClassCancelled);
      setTable2Data(
        list.map((item, index) => ({
          ...item,
          index: (page - 1) * countPerPage + index + 1,
        }))
      );
    } catch (error) {
      console.error("Error loading attendance list:", error);
    }
  }, [page, timeSlot2, countPerPage, sortingBy, direction]);

  const fetchStudentAttendanceListData = useCallback(async () => {
    try {
      const params = {
        startDate: data.Start_Date,
        endDate: data.End_Date,
        page,
        countPerPage: 7,
        sortingBy,
        direction
      };

      let apiUrl = "https://api.kunalsdrumclass.com/api/GetStudentAttendanceReportByStudentId";
      params.studentId = user?.Id;
      const query = new URLSearchParams(params).toString();
      const res = await fetch(`${apiUrl}?${query}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await res.json();
      const list = result?.recordsets?.[0] || [];
      const total = result?.recordsets?.[1]?.[0]?.TotalRows;
      setTable2Data(
        list.map((item, index) => ({
          ...item,
          index: (page - 1) * countPerPage + index + 1,
        }))
      );

    } catch (error) {
      console.error("API Error:", error);
    }
  }, [data, page, countPerPage, sortingBy, direction, user]);

  useEffect(() => {
    fetchBatchSlots(classDate);
  }, [classDate, fetchBatchSlots]);

  useEffect(() => {
    if (!user) return;

    if (role === "Student") {
      fetchStudentDashboard();
    } else {
      fetchDashboardData();
      fetchFinalListData();
      fetchAttendanceListData();
    }
  }, [user, role, fetchDashboardData, fetchFinalListData, fetchAttendanceListData, fetchStudentDashboard]);

  useEffect(() => {
    if (role === "Student" && data?.Start_Date && data?.End_Date) {
      fetchStudentAttendanceListData();
    }
  }, [data]);

  useEffect(() => {
    const users = localStorage.getItem("authUsers");
    const activeUser = localStorage.getItem("authUser");

    if (users) {
      const parsedUsers = JSON.parse(users);
      const usersArray = Array.isArray(parsedUsers)
        ? parsedUsers
        : [parsedUsers];

      setAllUsers(usersArray);

      if (activeUser) {
        setUser(JSON.parse(activeUser));
      } else {
        setUser(usersArray[0]);
        localStorage.setItem("authUser", JSON.stringify(usersArray[0]));
      }
    }
  }, []);

  useEffect(() => {
    if (data) {
      setCurrentMonthRequest(data.current_newrequest_count);
      setPreviousMonthRequest(data.previous_newrequest_count);

      const requestCalc = calculatePercentage(
        data.current_newrequest_count,
        data.previous_newrequest_count
      );
      setRequestPercentage(requestCalc.percentage);
      setRequestPercentageType(requestCalc.type);


      setCurrentMonthStudent(data.current_student_count);
      setPreviousMonthStudent(data.previous_student_count);

      const studentCalc = calculatePercentage(
        data.current_student_count,
        data.previous_student_count
      );
      setStudentPercentage(studentCalc.percentage);
      setStudentPercentageType(studentCalc.type);


      setCurrentMonthPayment(data.current_payment);
      setPreviousMonthPayment(data.previous_payment);

      const paymentCalc = calculatePercentage(
        parseFloat(data.current_payment),
        parseFloat(data.previous_payment)
      );
      setPaymentPercentage(paymentCalc.percentage);
      setPaymentPercentageType(paymentCalc.type);


      setCurrentMonthPause(data.current_pause_count);
      setPreviousMonthPause(data.previous_pause_count);

      const pauseCalc = calculatePercentage(
        data.current_pause_count,
        data.previous_pause_count
      );
      setPausePercentage(pauseCalc.percentage);
      setPausePercentageType(pauseCalc.type);
    }
  }, [data]);

  const calculatePercentage = (current, previous) => {
    if (!previous || previous === 0) {
      return { percentage: 100, type: "up" };
    }

    const diff = ((current - previous) / previous) * 100;

    return {
      percentage: Math.abs(diff.toFixed(2)),
      type: diff >= 0 ? "up" : "down",
    };
  };

  const toggle = () => {
    setMenu(!menu);
  };

  const onTimeSlotChange1 = (time) => {
    setTimeSlot1(time);
    setPage(1);
  };

  const onTimeSlotChange2 = (time) => {
    setTimeSlot2(time);
    setPage(1);
  };

  document.title = "Dashboard | KDC - Kunal's Drum Class";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md="8" xs="6">
                <h6 className="page-title">Dashboard</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    <div className="d-flex align-items-center">
                      <span style={{ fontSize: "larger" }}>Welcome Back</span>

                      {allUsers.length > 1 ? (
                        <Dropdown className="ms-1" isOpen={singlebtn} toggle={() => setSinglebtn(!singlebtn)}>
                          <DropdownToggle
                            caret
                            className="btn btn-secondary btn-md"
                          >
                            {user?.Name || "Select User"}
                            <i className="mdi mdi-chevron-down" />
                          </DropdownToggle>

                          <DropdownMenu>
                            {allUsers.map((u, index) => (
                              <DropdownItem
                                key={index}
                                active={user?.Name === u.Name}
                                onClick={() => {
                                  setUser(u);
                                  localStorage.setItem("authUser", JSON.stringify(u));
                                  window.dispatchEvent(new Event("authUserChanged"));
                                  setSinglebtn(false);
                                }}
                              >
                                {u.Name}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      ) : (
                        <span className="fw-semibold ms-1" style={{ fontSize: "larger" }}>{user?.Name || "User"}</span>
                      )}
                      <span>,</span>
                    </div>
                  </li>
                </ol>
              </Col>

              <Col md="4" xs="6">
                <div className="float-end">
                  <EnableNotificationsButton emailAddress={email} role={role} />
                </div>
              </Col>
            </Row>
          </div>

          {(role === "Super Admin" || role === "Admin") && (
            <>
              <Row>
                <Col xl={3} md={6}>
                  <Card className="mini-stat bg-primary text-white">
                    <CardBody>
                      <Link to="/students" state={{ activeTab: "new" }} className="text-white-50">
                        <div className="mb-4">
                          <div className="d-flex align-items-center gap-3">
                            <div className="mini-stat-img">
                              <img src={servicesIcon3} alt="" />
                            </div>
                            <div>
                              <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                                New Requests
                              </h5>
                              <h4 className="fw-medium font-size-24">
                                {currentMonthRequest}{" "}
                                {requestPercentageType === "up" ? (
                                  <i className="mdi mdi-arrow-up text-white ms-2"></i>
                                ) : (
                                  <i className="mdi mdi-arrow-down text-white ms-2"></i>
                                )}
                              </h4>
                            </div>
                          </div>
                          <div
                            className={`mini-stat-label ${requestPercentageType === "up" ? "bg-success" : "bg-danger"
                              }`}
                            style={{ top: "88px" }}
                          >
                            <p className="mb-0">
                              {requestPercentageType === "up" ? "+" : "-"} {requestPercentage}%
                            </p>
                          </div>
                        </div>
                        <div className="pt-2">
                          <div className="float-end">
                            <i className="mdi mdi-arrow-right h5"></i>
                          </div>
                          <p className="text-white-50 mb-0">Since last month</p>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} md={6}>
                  <Card className="mini-stat bg-primary text-white">
                    <CardBody>
                      <Link to="/students" className="text-white-50">
                        <div className="mb-4">
                          <div className="d-flex align-items-center gap-3">
                            <div className="mini-stat-img">
                              <img src={servicesIcon2} alt="" />
                            </div>
                            <div>
                              <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                                Total Students
                              </h5>
                              <h4 className="fw-medium font-size-24">
                                {currentMonthStudent}{" "}
                                {studentPercentageType === "up" ? (
                                  <i className="mdi mdi-arrow-up text-white ms-2"></i>
                                ) : (
                                  <i className="mdi mdi-arrow-down text-white ms-2"></i>
                                )}
                              </h4>
                            </div>
                          </div>
                          <div
                            className={`mini-stat-label ${studentPercentageType === "up" ? "bg-success" : "bg-danger"
                              }`}
                            style={{ top: "88px" }}
                          >
                            <p className="mb-0">
                              {studentPercentageType === "up" ? "+" : "-"} {studentPercentage}%
                            </p>
                          </div>
                        </div>
                        <div className="pt-2">
                          <div className="float-end">
                            <i className="mdi mdi-arrow-right h5"></i>
                          </div>
                          <p className="text-white-50 mb-0">Since last month</p>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} md={6}>
                  <Card className="mini-stat bg-primary text-white">
                    <CardBody>
                      <Link to="/students" state={{ activeTab: "pause" }} className="text-white-50">
                        <div className="mb-4">
                          <div className="d-flex align-items-center gap-3">
                            <div className="mini-stat-img">
                              <img src={servicesIcon4} alt="" />
                            </div>
                            <div>
                              <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                                Pause Students
                              </h5>
                              <h4 className="fw-medium font-size-24">
                                {currentMonthPause}{" "}
                                {pausePercentageType === "up" ? (
                                  <i className="mdi mdi-arrow-up text-white ms-2"></i>
                                ) : (
                                  <i className="mdi mdi-arrow-down text-white ms-2"></i>
                                )}
                              </h4>
                            </div>
                          </div>
                          <div
                            className={`mini-stat-label ${pausePercentageType === "up" ? "bg-success" : "bg-danger"
                              }`}
                            style={{ top: "88px" }}
                          >
                            <p className="mb-0">
                              {pausePercentageType === "up" ? "+" : "-"} {pausePercentage}%
                            </p>
                          </div>
                        </div>
                        <div className="pt-2">
                          <div className="float-end">
                            <i className="mdi mdi-arrow-right h5"></i>
                          </div>
                          <p className="text-white-50 mb-0">Since last month</p>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} md={6}>
                  <Card className="mini-stat bg-primary text-white">
                    <CardBody>
                      <Link to="/payments" className="text-white-50">
                        <div className="mb-4">
                          <div className="d-flex align-items-center gap-3">
                            <div className="mini-stat-img">
                              <img src={servicesIcon1} alt="" />
                            </div>
                            <div>
                              <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                                Payments
                              </h5>
                              <h4 className="fw-medium font-size-24">
                                {currentMonthPayment}{" "}
                                {paymentPercentageType === "up" ? (
                                  <i className="mdi mdi-arrow-up text-white ms-2"></i>
                                ) : (
                                  <i className="mdi mdi-arrow-down text-white ms-2"></i>
                                )}
                              </h4>
                            </div>
                          </div>
                          <div
                            className={`mini-stat-label ${paymentPercentageType === "up" ? "bg-success" : "bg-danger"
                              }`}
                            style={{ top: "88px" }}
                          >
                            <p className="mb-0">
                              {paymentPercentageType === "up" ? "+" : "-"} {paymentPercentage}%
                            </p>
                          </div>
                        </div>
                        <div className="pt-2">
                          <div className="float-end">
                            <i className="mdi mdi-arrow-right h5"></i>
                          </div>
                          <p className="text-white-50 mb-0">Since last month</p>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col xl={9} className="d-flex">
                  <Card className="h-100 w-100">
                    <CardBody>
                      <h4 className="card-title mb-4">Monthly Earning</h4>
                      <Row>
                        <Col lg={7}>
                          <div style={{ height: "450px" }}>
                            <BarChart />
                          </div>
                        </Col>
                        <Col lg={5}>
                          <Row>
                            <Col md={6}>
                              <div className="text-center">
                                <p className="text-muted mb-3">This month</p>
                                <h3>₹ {data.current_total_amount}</h3>
                                <Salesdonut
                                  series={[
                                    Number(data.current_cash_amount) || 0,
                                    Number(data.current_card_amount) || 0,
                                    Number(data.current_upi_amount) || 0,
                                    Number(data.current_bank_amount) || 0,
                                    Number(data.current_huf_amount) || 0,
                                    Number(data.current_current_amount) || 0,
                                  ]}
                                />
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="text-center">
                                <p className="text-muted mb-3">Last month</p>
                                <h3>₹ {data.previous_total_amount}</h3>
                                <Salesdonut
                                  series={[
                                    Number(data.previous_cash_amount) || 0,
                                    Number(data.previous_card_amount) || 0,
                                    Number(data.previous_upi_amount) || 0,
                                    Number(data.previous_bank_amount) || 0,
                                    Number(data.previous_huf_amount) || 0,
                                    Number(data.previous_current_amount) || 0,
                                  ]}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                <Col xl={3} className="d-flex">
                  <Card className="h-100 w-100">
                    <CardBody>
                      <div>
                        <h4 className="card-title mb-4">Payment Analytics (Monthly)</h4>
                      </div>
                      <div className="wid-peity mb-3">
                        <div className="row">
                          <div className="col-8 col-md-7">
                            <div>
                              <p className="text-muted">Cash</p>
                              <h5 className="mb-3">₹ {data.current_cash_amount}</h5>
                            </div>
                          </div>
                          <div className="col-4 col-md-5">
                            <div className="mb-3">
                              <img src={cash} style={{ maxWidth: "100px" }} className="mt-2" alt="kdc" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="wid-peity mb-3">
                        <div className="row">
                          <div className="col-8 col-md-7">
                            <div>
                              <p className="text-muted">Kunal (ICICI Savings)</p>
                              <h5 className="mb-3">₹ {data.current_card_amount}</h5>
                            </div>
                          </div>
                          <div className="col-4 col-md-5">
                            <div className="mb-3">
                              <img src={bank} style={{ maxWidth: "100px" }} className="mt-2" alt="kdc" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="wid-peity mb-3">
                        <div className="row">
                          <div className="col-8 col-md-7">
                            <div>
                              <p className="text-muted">Poornima (CCBL)</p>
                              <h5 className="mb-3">₹ {data.current_upi_amount}</h5>
                            </div>
                          </div>
                          <div className="col-4 col-md-5">
                            <div className="mb-3">
                              <img src={bank} style={{ maxWidth: "100px" }} className="mt-2" alt="kdc" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="wid-peity mb-3">
                        <div className="row">
                          <div className="col-8 col-md-7">
                            <div>
                              <p className="text-muted">Poornima (HDFC)</p>
                              <h5 className="mb-3">₹ {data.current_bank_amount}</h5>
                            </div>
                          </div>
                          <div className="col-4 col-md-5">
                            <div className="mb-3">
                              <img src={bank} style={{ maxWidth: "100px" }} className="mt-2" alt="kdc" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="wid-peity mb-3">
                        <div className="row">
                          <div className="col-8 col-md-7">
                            <div>
                              <p className="text-muted">Kunal (HUF)</p>
                              <h5 className="mb-3">₹ {data.current_huf_amount}</h5>
                            </div>
                          </div>
                          <div className="col-4 col-md-5">
                            <div className="mb-3">
                              <img src={bank} style={{ maxWidth: "100px" }} className="mt-2" alt="kdc" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="">
                        <div className="row">
                          <div className="col-8 col-md-7">
                            <div>
                              <p className="text-muted">KDC (ICICI Current)</p>
                              <h5>₹ {data.current_current_amount}</h5>
                            </div>
                          </div>
                          <div className="col-4 col-md-5">
                            <div className="mb-3">
                              <img src={bank} style={{ maxWidth: "100px" }} className="mt-2" alt="kdc" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row className="mt-4">
                <Col xl={5}>
                  <Card>
                    <CardBody>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="card-title mb-0">Today's Final Student List</h4>

                        <select
                          className="form-select pageSize"
                          style={{ width: "200px" }}
                          value={timeSlot1}
                          onChange={e => onTimeSlotChange1(e.target.value)}
                        >
                          {timeSlots.map((slot, index) => {
                            const slotValue = slot.Batch_Time;

                            return (
                              <option key={index} value={slotValue}>
                                {slotValue}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-hover table-centered table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th scope="col">Id</th>
                              <th scope="col">Name</th>
                              <th scope="col">Class Type</th>
                            </tr>
                          </thead>
                          <tbody>
                            {table1Data.length > 0 ? (
                              table1Data.map((table, index) => (
                                <tr key={index}>
                                  <th scope="row">{table.Student_Id}</th>
                                  <td>{table.Student_Name}</td>
                                  <td>{table.Booking_Type}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3" className="text-center">
                                  {isFinalListCancelled
                                    ? <>
                                      <div>
                                        <h5 className="mb-2">
                                          Class Close By Admin
                                        </h5>

                                        <p className="text-muted mb-0">
                                          This class has been closed by the admin. Please check report for more details.
                                        </p>
                                      </div>
                                    </>
                                    : "No records found"}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={7}>
                  <Card>
                    <CardBody>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="card-title mb-0">Today's Attendance List</h4>

                        <select
                          className="form-select pageSize"
                          style={{ width: "200px" }}
                          value={timeSlot2}
                          onChange={e => onTimeSlotChange2(e.target.value)}
                        >
                          {timeSlots.map((slot, index) => {
                            const slotValue = slot.Batch_Time;

                            return (
                              <option key={index} value={slotValue}>
                                {slotValue}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-hover table-centered table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th scope="col">Id</th>
                              <th scope="col">Name</th>
                              <th scope="col">Class Type</th>
                              <th scope="col">Attendance Time</th>
                              <th scope="col">
                                Status
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {table2Data.length > 0 ? (
                              table2Data.map((table, index) => (
                                <tr key={index}>
                                  <th scope="row">{table.Student_Id}</th>
                                  <td>{table.Student_Name}</td>
                                  <td>{table.Booking_Type}</td>
                                  <td>
                                    {table.CreatedOn
                                      ? moment(table.CreatedOn).format("DD-MM-YYYY hh:mm A")
                                      : "Not Taken Yet"}
                                  </td>
                                  <td>
                                    <span
                                      className={`badge ${table.Attendance_Status === "Present"
                                        ? "bg-success"
                                        : table.Attendance_Status === "Absent"
                                          ? "bg-danger"
                                          : "bg-warning"
                                        }`}
                                    >
                                      {table.Attendance_Status ?? "Pending"}
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  {isAttendanceCancelled
                                    ? <>
                                      <div>
                                        <h5 className="mb-2">
                                          Class Close By Admin
                                        </h5>

                                        <p className="text-muted mb-0">
                                          This class has been closed by the admin. Please check report for more details.
                                        </p>
                                      </div>
                                    </>
                                    : "No records found"}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          )}

          {role === "Student" && (
            <>
              <Row>
                <Col xl={12} md={12} className="mb-4">
                  <InfiniteText token={token} />
                </Col>
              </Row>
              <Row>
                <Col xl={3} md={6}>
                  <Card className="mini-stat bg-primary text-white">
                    <CardBody>
                      <div className="mb-5">
                        <div className="d-flex align-items-center gap-3">
                          <div className="mini-stat-img">
                            <img src={servicesIcon1} alt="" />
                          </div>
                          <div>
                            <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                              Class Duration
                            </h5>
                            <h4 className="fw-medium font-size-24">
                              {data.Class_Duration} {"Month"}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} md={6}>
                  <Card className="mini-stat bg-primary text-white">
                    <CardBody>
                      <div className="mb-5">
                        <div className="d-flex align-items-center gap-3">
                          <div className="mini-stat-img">
                            <img src={servicesIcon2} alt="" />
                          </div>
                          <div>
                            <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                              Fix Class
                            </h5>
                            <h4 className="fw-medium font-size-24">
                              {data.Fix_Class_Count} {""}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} md={6}>
                  <Card className="mini-stat bg-primary text-white">
                    <CardBody>
                      <div className="mb-5">
                        <div className="d-flex align-items-center gap-3">
                          <div className="mini-stat-img">
                            <img src={servicesIcon3} alt="" />
                          </div>
                          <div>
                            <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                              Attended Comp
                            </h5>
                            <h4 className="fw-medium font-size-24">
                              {data.Comp_Class_Count} {""}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} md={6}>
                  <Card className="mini-stat bg-primary text-white">
                    <CardBody>
                      <div className="">
                        <div className="d-flex align-items-start gap-3">
                          <div className="mini-stat-img">
                            <img src={servicesIcon4} alt="" />
                          </div>

                          <div className="w-100">
                            <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                              Remaining Comp
                            </h5>

                            <h4 className="fw-medium font-size-24">
                              {data.Pending_Class_Count} {""}
                            </h4>

                            <div className="small">
                              <div className="d-flex justify-content-between mt-4">
                                <span>Close Class By KDC:</span>
                                <strong>{data.Close_Class_Count} {""}</strong>
                              </div>

                              <div className="d-flex justify-content-between">
                                <span>Other Comp Count:</span>
                                <strong> {(data.Pending_Class_Count || 0) - (data.Close_Class_Count || 0)}</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col xl={9} className="d-flex">
                  <Card className="h-100 w-100">
                    <CardBody>
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="card-title mb-0">Attendance List</h4>

                        <Link to="/attendance-report" className="text-white-50">
                          <button className="btn btn-primary waves-effect waves-light">
                            View In Report
                          </button>
                        </Link>
                      </div>
                      <Row>
                        <Col lg={12}>
                          <div>
                            <div className="table-responsive">
                              <table className="table table-hover table-centered table-nowrap mb-0">
                                <thead>
                                  <tr>
                                    <th scope="col">Id</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Time</th>
                                    <th scope="col">
                                      Status
                                    </th>
                                    <th scope="col">
                                      Created Date
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {table2Data.length > 0 ? (
                                    table2Data.map((table, index) => (
                                      <tr key={index}>
                                        <th scope="row">{table.Id}</th>
                                        <td>{table.Student_Name}</td>
                                        <td>{table.Class_Date}</td>
                                        <td>{table.Time_Slot}</td>
                                        <td>
                                          <span
                                            className={`badge ${table.Attendance_Status === "Present"
                                              ? "bg-success"
                                              : table.Attendance_Status === "Absent"
                                                ? "bg-danger"
                                                : "bg-warning"
                                              }`}
                                          >
                                            {table.Attendance_Status}
                                          </span>
                                        </td>
                                        <td>
                                          {table.CreatedOn
                                            ? moment(table.CreatedOn).format("DD-MM-YYYY hh:mm A")
                                            : "Not Taken Yet"}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="6" className="text-center">
                                        No records found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                <Col xl={3} className="d-flex">
                  <Card className="h-100 w-100">
                    <CardBody>
                      <div>
                        <h4 className="card-title mb-4">Payment Analytics</h4>
                      </div>
                      <div className="text-center">
                        <h3>₹ {data.Total_Amount}</h3>
                        <Salesdonut1
                          series={[
                            Number(data.Cash_Amount) || 0,
                            Number(data.Card_Amount) || 0,
                            Number(data.UPI_Amount) || 0,
                            Number(data.Bank_Amount) || 0,
                            Number(data.Huf_Amount) || 0,
                            Number(data.Current_Amount) || 0,
                          ]}
                        />

                        <Link to="/paymentstatus-report" className="text-white-50">
                          <button
                            className="btn btn-primary dropdown-toggle waves-effect waves-light mt-3"
                          >
                            View In Report
                          </button>
                        </Link>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          )}

          {role !== "Super Admin" && role !== "Admin" && role !== "Student" && (
            <>
            </>
          )}
        </Container>
      </div>

    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any
};

export default Dashboard;
